import {
  ModelBase,
  CreatableModel,
  ModifiableModel,
  DeletableModel,
} from 'shared/domain/baseModelTypes';
import { Identificable } from 'shared/types/commonView';

export enum InvolvementType {
  SUBCONTRACTOR = 'SUBCONTRACTOR',
  GENERAL_CONTRACTOR = 'GENERAL_CONTRACTOR',
  INVESTOR = 'INVESTOR',
}

/** A company address; the API takes it only complete (every part required). */
export interface CompanyAddress {
  streetAndNumber?: string;
  postalCode?: string;
  city?: string;
  /** ISO 3166-1 alpha-3 code, e.g. `POL`. */
  country?: string;
}

/** The addresses of a company, in the order the forms show them. */
export const companyAddressKinds = ['registeredOfficeAddress', 'correspondenceAddress'] as const;
export type CompanyAddressKind = (typeof companyAddressKinds)[number];

/** The text parts of an address, in the order the forms show them (the country follows). */
export const companyAddressTextParts = ['streetAndNumber', 'postalCode', 'city'] as const;
export type CompanyAddressTextPart = (typeof companyAddressTextParts)[number];
export type CompanyAddressPart = CompanyAddressTextPart | 'country';

export type CompanyAddresses = Partial<Record<CompanyAddressKind, CompanyAddress>>;

/** Addresses of an edit: `null` removes an address the form emptied. */
export type CompanyAddressChanges = Partial<Record<CompanyAddressKind, CompanyAddress | null>>;

interface BaseCompany extends CompanyAddresses {
  // contracts: string[];
  longLabel: string;
  projectInvolvementType: InvolvementType;
  shortLabel: string;
  sites: string[];
  taxNumber?: string;
}

export type CompanyModel = ModelBase & BaseCompany;

export type CompanyCreateModel = CreatableModel &
  ModifiableModel &
  DeletableModel &
  BaseCompany & { projectId: string };

export type CompanyEditModel = Identificable &
  Omit<BaseCompany, CompanyAddressKind> &
  CompanyAddressChanges & { projectId: string };

export const involvementTypes = [
  InvolvementType.SUBCONTRACTOR,
  InvolvementType.GENERAL_CONTRACTOR,
  InvolvementType.INVESTOR,
];
